export const trTravelReasons= [
  { value: '1', label: 'Müşteri Ziyareti' },
  { value: '2', label: 'ZEISS İçi Eğitim/Toplantı' },
  { value: '3', label: 'Servis Desteği' },
  { value: '4', label: 'İhale' },
  { value: '5', label: 'Fuar/Kongre (Her şey dahil)' },
  { value: '6', label: 'Fuar/Kongre' },
  { value: '7', label: 'SSC Meeting' },
  { value: '8', label: 'Demo/Aplikasyon' },
  { value: '10', label: 'Tedarikçi Ziyareti' },
  { value: '9', label: 'Diğer' }

];

export const enTravelReasons= [
  { value: '1', label: 'Customer Visit' },
  { value: '2', label: 'Internal ZEISS Training/Meeting' },
  { value: '3', label: 'Service Support' },
  { value: '4', label: 'Tender' },
  { value: '5', label: 'Fair / Congress (All Inclusive)' },
  { value: '6', label: 'Fair/Congress' },
  { value: '7', label: 'SSC Meeting' },
  { value: '8', label: 'Demo/Applications' },
  { value: '10', label: 'Supplier Visit' },
  { value: '9', label: 'Other' }
];



// WEBPACK FOOTER //
// ./src/mock/travel-reasons.js